import React from 'react';
import { ModalFactory } from '@Components';
import ReferInstructions from '../refer-instructions/ReferInstruction';
import CopyPopup from 'semantic-ui-react/dist/commonjs/modules/Popup';
import { compileTemplateNew, copyCommand } from '../../../utils/library';
import { ReferCardProps } from '../interface';
import ReferQrCode from '../refer-qr/referQr';
import { connect } from 'react-redux';
import { activateLoader } from '../../../redux/actions/ui-trigger/ui-trigger-action';
import { bindActionCreators } from 'redux';
import { IStore } from '../../../store.type';
import {
  REFFERAL_COPY,
  REFFERAL_MAIL,
  REFFERAL_QR
} from '../../../utils/constants/eventsConstants';
import { CASH_ICON, COPY_ICON, INSTAREM_APP_QR_CODE_ICON, MAIL_ICON } from '@Images';
import { RefferalCard, ImportantInfoSection, List } from './styles';
import { logEventV2 } from '@Utils/events/logUserEvents';
import {
  EVENT_ROUTE_KEYS,
  EventButtonType,
  EventNamesV2,
  FLOW_TYPE
} from '@Utils/events/eventsConstants';

const ReferCard: React.FC<ReferCardProps> = ({
  rewardData,
  labels,
  url,
  currency,
  activateLoader
}): React.ReactElement => {
  const openModalScreen = async (Child: any, props: any) => {
    // @ts-ignore
    return await ModalFactory.builder?.(
      (onClose: any) => <Child {...props} onClose={onClose}></Child>,
      'insta-modal center-modal',
      true
    );
  };

  const rewards = rewardData?.rewards;
  const labelShareData = labels?.shareData;
  const importantInfo = labels?.importantInfo;
  const CURRENCY = currency;
  const MIN_TRANSFER_AMOUNT = '2500 SGD';

  const logEvents = (ctaName: string) => {
    const eventProperty = {
      type: EventButtonType.BUTTON,
      pageName: EVENT_ROUTE_KEYS.ReferAndEarn,
      ctaName,
      flowType: FLOW_TYPE.REFERRALS
    };
    logEventV2(EventNamesV2.CTA_CLICKED, eventProperty);
  };

  return (
    <RefferalCard>
      <div className="referralCard">
        <div className="referDescription">
          <img alt="cashIcon" src={CASH_ICON}></img>
          <div className="textDescription">
            <span className="boldHead">{labels?.heading}</span>
            <span className="smallHead">{labels?.description}</span>
            <button
              className="workText"
              onClick={() => {
                openModalScreen(ReferInstructions, { labels: labels });
                logEvents(labels?.howItWork);
              }}
            >
              {labels?.howItWork}
            </button>
          </div>
          <div className="rewardDescription">
            <span className="promotionText">{labels?.promotionText}</span>
            <div className="rewardSummary">
              <>
                <div className="refereeReward">
                  <div className="leftReward">
                    <span className="amountBoldText">{rewards?.youGet}</span>
                    <span className="amountNormalText">{rewards?.couponName}</span>
                  </div>
                  <div className="rightReward">
                    <span className="amountNormalText">{rewards?.worth}</span>
                    <span className="amountBoldText">{rewards?.couponValue}</span>
                  </div>
                </div>
                <div className="referredReward">
                  <div className="leftReward">
                    <span className="amountBoldText">{rewards?.theyGet}</span>
                    <span className="amountNormalText">{rewards?.ipValue}</span>
                  </div>
                  <div className="rightReward">
                    <span className="amountNormalText">{rewards?.worth}</span>
                    <span className="amountBoldText">{rewards?.ipRedeemValue}</span>
                  </div>
                </div>
              </>

              <div className="importantinfoCard">
                <div className="heading">{importantInfo?.title}</div>
                <List>
                  {importantInfo?.config?.map((item: { message: string }, index: number) => (
                    <ImportantInfoSection key={index}>
                      <span className="text">
                        {compileTemplateNew(item?.message, {
                          CURRENCY,
                          MIN_TRANSFER_AMOUNT
                        })}
                      </span>
                    </ImportantInfoSection>
                  ))}
                </List>
              </div>
            </div>
          </div>
        </div>
        <div className="linkDescription">
          <div className="referLink">
            <span className="shareText">{labelShareData?.heading}</span>
            <div className="linkBox">
              <div className="inviteLink">
                <span id="refferal_link">{url}</span>
              </div>
              <div className="sharedApps">
                <CopyPopup
                  id="iconButton"
                  on="click"
                  style={{ width: '90px', left: '-16px' }}
                  hideOnScroll={true}
                  trigger={
                    <img
                      className="iconButton"
                      onClick={() => {
                        copyCommand('refferal_link');
                        logEvents(REFFERAL_COPY);
                      }}
                      src={COPY_ICON}
                      alt="copy"
                    />
                  }
                  content={'Copied!!'}
                />
                <button
                  onClick={() => {
                    openModalScreen(ReferQrCode, { labels: labels, url: url });
                    logEvents(REFFERAL_QR);
                  }}
                  className="qrButton"
                >
                  <img className="qrIcon" src={INSTAREM_APP_QR_CODE_ICON} alt="qrIcon" />
                </button>
                <a
                  href={`mailto:?subject=${labelShareData?.shareSubject}&body=${labelShareData?.shareMessage}%0D%0A${url}`}
                  id="gmail-link"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => logEvents(REFFERAL_MAIL)}
                >
                  <img src={MAIL_ICON} alt="gmail-icon" />
                </a>
              </div>
            </div>
          </div>
          <div className="termsConditions">
            <span>
              {labelShareData?.termsReadMoreText}
              <a
                href={labels?.tncLink}
                className="linkText"
                onClick={() => {
                  logEvents(labelShareData?.termsApply);
                  activateLoader && activateLoader();
                }}
              >
                {' '}
                {labelShareData?.termsApply}
              </a>
            </span>
          </div>
        </div>
      </div>
    </RefferalCard>
  );
};

export default connect<any, any, any, IStore>(null, (dispatch: any) =>
  bindActionCreators({ activateLoader }, dispatch)
)(ReferCard);
